module.exports = __webpack_public_path__ + "static/adidas-e80a88c1a0992e314cc37998b0128f54.png";